import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cancel-info',
  templateUrl: './cancel-info.component.html',
  styleUrls: ['./cancel-info.component.css']
})
export class CancelInfoComponent {
  @Input() approved: boolean = false;  
}
